import { NgModule } from '@angular/core'
import { provideEffects } from '@ngrx/effects'
import { provideState } from '@ngrx/store'
import { BossServiceOrganizationEffects, BossServiceOrganizationFeature } from 'se-fe-data-access/boss-service-organization'
import { MembershipServiceMembershipEffects, MembershipServiceMembershipFeature } from 'se-fe-data-access/membership-service-membership'
import { NginAdminManagementEffects, NginAdminManagementFeature } from 'se-fe-data-access/ngin-admin-management'
import { NginDibItemEffects, NginDibItemFeature } from 'se-fe-data-access/ngin-dib-item'
import { NginDibSessionEffects, NginDibSessionFeature } from 'se-fe-data-access/ngin-dib-session'
import { NginGroupEffects, NginGroupFeature } from 'se-fe-data-access/ngin-group'
import { NginContactListEffects, NginContactListFeature } from 'se-fe-data-access/ngin-contact-list'
import { NginUserPersonaEffects, NginUserPersonaFeature } from 'se-fe-data-access/ngin-user-persona'
import { NginSurveyResultEffects, NginSurveyResultFeature } from 'se-fe-data-access/ngin-survey-result'
import { TeamServiceRosterPersonaEffects, TeamServiceRosterPersonaFeature } from 'se-fe-data-access/team-service-roster-persona'
import { TeamServiceRosterHistoryEffects, TeamServiceRosterHistoryFeature } from 'se-fe-data-access/team-service-roster-history'
import { UserServicePersonaEffects, UserServicePersonaFeature } from 'se-fe-data-access/user-service-persona'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { ProfileSidePanelComponent } from './profile-side-panel/profile-side-panel.component'
import { NginInvoicesEffects, NginInvoicesFeature } from 'se-fe-data-access/ngin-invoices'
import { ClareAccountingOrderEffects, ClareAccountingOrderFeature } from 'se-fe-data-access/clare-accounting-order'

@NgModule({
  imports: [
    SeFeTranslationsModule,
    ProfileSidePanelComponent
  ],
  declarations: [],
  exports: [ProfileSidePanelComponent],
  providers: [
    provideState(
      BossServiceOrganizationFeature.BOSS_SERVICE_ORGANIZATION_FEATURE_KEY,
      BossServiceOrganizationFeature.bossServiceOrganizationReducer
    ),
    provideState(
      MembershipServiceMembershipFeature.MEMBERSHIP_SERVICE_MEMBERSHIP_FEATURE_KEY,
      MembershipServiceMembershipFeature.membershipServiceMembershipReducer
    ),
    provideState(
      NginAdminManagementFeature.NGIN_ADMIN_MANAGEMENT_FEATURE_KEY,
      NginAdminManagementFeature.nginAdminManagementReducer
    ),
    provideState(
      NginSurveyResultFeature.NGIN_SURVEY_RESULT_FEATURE_KEY,
      NginSurveyResultFeature.nginSurveyResultReducer
    ),
    provideState(
      NginGroupFeature.NGIN_GROUP_FEATURE_KEY,
      NginGroupFeature.nginGroupReducer
    ),
    provideState(
      NginContactListFeature.NGIN_CONTACT_LIST_FEATURE_KEY,
      NginContactListFeature.nginContactListReducer
    ),
    provideState(
      UserServicePersonaFeature.USER_SERVICE_PERSONA_FEATURE_KEY,
      UserServicePersonaFeature.userServicePersonaReducer
    ),
    provideState(
      NginUserPersonaFeature.NGIN_USER_PERSONA_FEATURE_KEY,
      NginUserPersonaFeature.nginUserPersonaReducer
    ),
    provideState(
      TeamServiceRosterPersonaFeature.TEAM_SERVICE_ROSTER_PERSONA_FEATURE_KEY,
      TeamServiceRosterPersonaFeature.teamServiceRosterPersonaReducer
    ),
    provideState(
      TeamServiceRosterHistoryFeature.TEAM_SERVICE_ROSTER_HISTORY_FEATURE_KEY,
      TeamServiceRosterHistoryFeature.teamServiceRosterHistoryReducer
    ),
    provideState(
      NginInvoicesFeature.NGIN_INVOICES_FEATURE_KEY,
      NginInvoicesFeature.nginInvoicesReducer
    ),
    provideState(
      ClareAccountingOrderFeature.CLARE_ACCOUNTING_ORDER_FEATURE_KEY,
      ClareAccountingOrderFeature.clareAccountingOrderReducer
    ),
    provideState(
      NginDibSessionFeature.NGIN_DIB_SESSION_FEATURE_KEY,
      NginDibSessionFeature.nginDibSessionReducer
    ),
    provideState(
      NginDibItemFeature.NGIN_DIB_ITEM_FEATURE_KEY,
      NginDibItemFeature.nginDibItemReducer
    ),
    provideEffects([
      BossServiceOrganizationEffects,
      MembershipServiceMembershipEffects,
      NginAdminManagementEffects,
      NginGroupEffects,
      NginContactListEffects,
      UserServicePersonaEffects,
      NginSurveyResultEffects,
      NginUserPersonaEffects,
      TeamServiceRosterPersonaEffects,
      TeamServiceRosterHistoryEffects,
      NginInvoicesEffects,
      ClareAccountingOrderEffects,
      NginDibSessionEffects,
      NginDibItemEffects,
    ]),
  ],
})
export class SharedFeatureProfileSidePanelModule {}
